module.exports = __webpack_public_path__ + "static/media/wallfinishes_gwp_10y_n.80b60751.csv";